/**
 * @fileoverview SEO Provider component for global SEO setup.
 */

import type { ReactNode } from 'react';
import { LocalBusinessStructuredData, ReservationActionStructuredData } from './StructuredData';

interface SEOProviderProps {
  /** Child components */
  children: ReactNode;
  /** Include local business structured data */
  includeLocalBusiness?: boolean;
  /** Include reservation action structured data */
  includeReservationAction?: boolean;
}

/**
 * SEOProvider wraps the app and injects global SEO elements.
 * This should be placed near the root of your application.
 */
export function SEOProvider({
  children,
  includeLocalBusiness = true,
  includeReservationAction = true,
}: SEOProviderProps) {
  return (
    <>
      {/* Global structured data */}
      {includeLocalBusiness && <LocalBusinessStructuredData />}
      {includeReservationAction && <ReservationActionStructuredData />}

      {/* App content */}
      {children}
    </>
  );
}

export default SEOProvider;
